/**
 * Created by andrey on 28.03.2024.
 */

const FirebaseLogger = function () {
    this.batch = [];

    this.sendBatch = connector.utils.accumulate(1000, this._sendBatch.bind(this));

    this.trackUserId();

    this.config = {
        lifetime: "180 days"
    };
};

FirebaseLogger.prototype.trackEvent = function (name, params) {
    if (name.length > 40) {
        console.warn(`Invalid event name: ${name}!. It must be between 1 and 40 characters, and must be contain only alphanumerics, , - or spaces, starting with alphanumeric or _.`);
    }

    this.send({
        method: "logEvent",
        name,
        data: params 
    });
};

FirebaseLogger.prototype.trackPurchase = function (product, purchase, params) {
    this.send({
        method: "logEvent",
        name: "purchase",
        data: {
            currency: params.currency,
            value: params.price,
            transaction_id: params.transactionId
        }
    });
};

FirebaseLogger.prototype.trackAdRevenue = function (name, impressionCost, params) {
    let source = params.source;
    switch (source) {
        case "ad_mob":
            return;
        case "app_lovin":
            source = "appLovin";
            break;
        case "yandex_app_ads":
            source = "yandex";
            break;
    }

    this.send({
        method: "logEvent",
        name: "ad_impression",
        data: {
            ad_platform: source,
            ad_format: name,
            value: impressionCost,
            currency: "USD"
        }
    });
};

FirebaseLogger.prototype.trackUserId = function () {
    this.send({
        method: "setUserID",
        id: connector.platform.getUserID()
    });
};

FirebaseLogger.prototype.send = function (params) {
    this.batch.push(params);
    this.sendBatch();
};

FirebaseLogger.prototype._sendBatch = function () {
    if (this.batch.length > 0) {
        connector.platform.callNative("FirebasePlugin.sendBatch", { batch: this.batch });
        this.batch = [];
    }
};

FirebaseLogger.isApplicable = function () {
    return connector.platform.oneOf(connector.AMAZON, connector.ANDROID, connector.IOS);
};